<script lang="ts">
  /*
   * A placeholder that occupies the space its content will take.
   *
   * Not a spinner: a spinner says "wait" and then everything below it jumps when the data lands. The
   * support site's rule is that nothing reflows in response to a tap; this is the same rule applied to a
   * fetch, and it is why every page that loads renders one of these at roughly its own shape.
   */
  let { rows = 3 }: { rows?: number } = $props()

  // Varied widths so it reads as text rather than as a broken table.
  const widths = ['70%', '92%', '55%', '84%', '63%']
</script>

<div class="loading" aria-busy="true" aria-live="polite">
  <span class="visually-hidden">Loading…</span>
  {#each Array(rows) as _, index}
    <div class="skeleton line" style:width={widths[index % widths.length]}></div>
  {/each}
</div>

<style>
  .loading {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-2) 0;
  }
  .line {
    height: 1.1rem;
  }
</style>
